export default function getBatchLabelXml() {
  /* eslint-disable */
  var labelXml = `<?xml version="1.0" encoding="utf-8"?>
<DieCutLabel Version="8.0" Units="twips">
\t<PaperOrientation>Landscape</PaperOrientation>
\t<Id>Small30336</Id>
\t<IsOutlined>false</IsOutlined>
\t<PaperName>30336 1 in x 2-1/8 in</PaperName>
\t<DrawCommands>
\t\t<RoundRectangle X="0" Y="0" Width="1440" Height="3060" Rx="180" Ry="180" />
\t</DrawCommands>
\t<ObjectInfo>
\t\t<DateTimeObject>
\t\t\t<Name>DATE-TIME</Name>
\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
\t\t\t<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
\t\t\t<LinkedObjectName />
\t\t\t<Rotation>Rotation0</Rotation>
\t\t\t<IsMirrored>False</IsMirrored>
\t\t\t<IsVariable>False</IsVariable>
\t\t\t<GroupID>-1</GroupID>
\t\t\t<IsOutlined>False</IsOutlined>
\t\t\t<HorizontalAlignment>Left</HorizontalAlignment>
\t\t\t<VerticalAlignment>Middle</VerticalAlignment>
\t\t\t<TextFitMode>ShrinkToFit</TextFitMode>
\t\t\t<UseFullFontHeight>True</UseFullFontHeight>
\t\t\t<Verticalized>False</Verticalized>
\t\t\t<DateTimeFormat>ShortSystemDate</DateTimeFormat>
\t\t\t<Font Family="Arial" Size="6" Bold="False" Italic="False" Underline="False" Strikeout="False" />
\t\t\t<PreText />
\t\t\t<PostText />
\t\t\t<IncludeTime>True</IncludeTime>
\t\t\t<Use24HourFormat>False</Use24HourFormat>
\t\t</DateTimeObject>
\t\t<Bounds X="130" Y="1238" Width="889.418495871803" Height="120" />
\t</ObjectInfo>
\t<ObjectInfo>
\t\t<BarcodeObject>
\t\t\t<Name>PATENTCODE</Name>
\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
\t\t\t<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
\t\t\t<LinkedObjectName />
\t\t\t<Rotation>Rotation0</Rotation>
\t\t\t<IsMirrored>False</IsMirrored>
\t\t\t<IsVariable>False</IsVariable>
\t\t\t<GroupID>-1</GroupID>
\t\t\t<IsOutlined>False</IsOutlined>
\t\t\t<Text>URL:www.forgenano.com</Text>
\t\t\t<Type>QRCode</Type>
\t\t\t<Size>Small</Size>
\t\t\t<TextPosition>None</TextPosition>
\t\t\t<TextFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
\t\t\t<CheckSumFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
\t\t\t<TextEmbedding>None</TextEmbedding>
\t\t\t<ECLevel>0</ECLevel>
\t\t\t<HorizontalAlignment>Center</HorizontalAlignment>
\t\t\t<QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
\t\t</BarcodeObject>
\t\t<Bounds X="2411.54545454545" Y="864.909090909091" Width="564.454545454545" Height="493.090909090909" />
\t</ObjectInfo>
\t<ObjectInfo>
\t\t<TextObject>
\t\t\t<Name>PatentText</Name>
\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
\t\t\t<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
\t\t\t<LinkedObjectName />
\t\t\t<Rotation>Rotation0</Rotation>
\t\t\t<IsMirrored>False</IsMirrored>
\t\t\t<IsVariable>False</IsVariable>
\t\t\t<GroupID>-1</GroupID>
\t\t\t<IsOutlined>False</IsOutlined>
\t\t\t<HorizontalAlignment>Left</HorizontalAlignment>
\t\t\t<VerticalAlignment>Top</VerticalAlignment>
\t\t\t<TextFitMode>AlwaysFit</TextFitMode>
\t\t\t<UseFullFontHeight>True</UseFullFontHeight>
\t\t\t<Verticalized>False</Verticalized>
\t\t\t<StyledText>
\t\t\t\t<Element>
\t\t\t\t\t<String xml:space="preserve">Patent Protected</String>
\t\t\t\t\t<Attributes>
\t\t\t\t\t\t<Font Family="Arial" Size="4" Bold="False" Italic="False" Underline="False" Strikeout="False" />
\t\t\t\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
\t\t\t\t\t</Attributes>
\t\t\t\t</Element>
\t\t\t</StyledText>
\t\t</TextObject>
\t\t<Bounds X="2411.54545454545" Y="769.090909090909" Width="564.454545454546" Height="120" />
\t</ObjectInfo>
\t<ObjectInfo>
\t\t<TextObject>
\t\t\t<Name>INIT</Name>
\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
\t\t\t<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
\t\t\t<LinkedObjectName />
\t\t\t<Rotation>Rotation0</Rotation>
\t\t\t<IsMirrored>False</IsMirrored>
\t\t\t<IsVariable>False</IsVariable>
\t\t\t<GroupID>-1</GroupID>
\t\t\t<IsOutlined>False</IsOutlined>
\t\t\t<HorizontalAlignment>Left</HorizontalAlignment>
\t\t\t<VerticalAlignment>Middle</VerticalAlignment>
\t\t\t<TextFitMode>ShrinkToFit</TextFitMode>
\t\t\t<UseFullFontHeight>True</UseFullFontHeight>
\t\t\t<Verticalized>False</Verticalized>
\t\t\t<StyledText>
\t\t\t\t<Element>
\t\t\t\t\t<String xml:space="preserve">Init _____</String>
\t\t\t\t\t<Attributes>
\t\t\t\t\t\t<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
\t\t\t\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
\t\t\t\t\t</Attributes>
\t\t\t\t</Element>
\t\t\t</StyledText>
\t\t</TextObject>
\t\t<Bounds X="1181.63636363636" Y="1238" Width="415.454545454547" Height="120" />
\t</ObjectInfo>
\t<ObjectInfo>
\t\t<TextObject>
\t\t\t<Name>BATCH</Name>
\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
\t\t\t<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
\t\t\t<LinkedObjectName />
\t\t\t<Rotation>Rotation0</Rotation>
\t\t\t<IsMirrored>False</IsMirrored>
\t\t\t<IsVariable>False</IsVariable>
\t\t\t<GroupID>-1</GroupID>
\t\t\t<IsOutlined>False</IsOutlined>
\t\t\t<HorizontalAlignment>Left</HorizontalAlignment>
\t\t\t<VerticalAlignment>Top</VerticalAlignment>
\t\t\t<TextFitMode>ShrinkToFit</TextFitMode>
\t\t\t<UseFullFontHeight>True</UseFullFontHeight>
\t\t\t<Verticalized>False</Verticalized>
\t\t\t<StyledText>
\t\t\t\t<Element>
\t\t\t\t\t<String xml:space="preserve">BATCH:</String>
\t\t\t\t\t<Attributes>
\t\t\t\t\t\t<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
\t\t\t\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
\t\t\t\t\t</Attributes>
\t\t\t\t</Element>
\t\t\t</StyledText>
\t\t</TextObject>
\t\t<Bounds X="130" Y="426.818181818182" Width="2435.81818181818" Height="120" />
\t</ObjectInfo>
\t<ObjectInfo>
\t\t<TextObject>
\t\t\t<Name>RUN</Name>
\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
\t\t\t<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
\t\t\t<LinkedObjectName />
\t\t\t<Rotation>Rotation0</Rotation>
\t\t\t<IsMirrored>False</IsMirrored>
\t\t\t<IsVariable>False</IsVariable>
\t\t\t<GroupID>-1</GroupID>
\t\t\t<IsOutlined>False</IsOutlined>
\t\t\t<HorizontalAlignment>Left</HorizontalAlignment>
\t\t\t<VerticalAlignment>Top</VerticalAlignment>
\t\t\t<TextFitMode>ShrinkToFit</TextFitMode>
\t\t\t<UseFullFontHeight>True</UseFullFontHeight>
\t\t\t<Verticalized>False</Verticalized>
\t\t\t<StyledText>
\t\t\t\t<Element>
\t\t\t\t\t<String xml:space="preserve">RUN:</String>
\t\t\t\t\t<Attributes>
\t\t\t\t\t\t<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
\t\t\t\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
\t\t\t\t\t</Attributes>
\t\t\t\t</Element>
\t\t\t</StyledText>
\t\t</TextObject>
\t\t<Bounds X="130" Y="1002" Width="2043.09090909091" Height="120" />
\t</ObjectInfo>
\t<ObjectInfo>
\t\t<TextObject>
\t\t\t<Name>MATERIAL</Name>
\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
\t\t\t<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
\t\t\t<LinkedObjectName />
\t\t\t<Rotation>Rotation0</Rotation>
\t\t\t<IsMirrored>False</IsMirrored>
\t\t\t<IsVariable>False</IsVariable>
\t\t\t<GroupID>-1</GroupID>
\t\t\t<IsOutlined>False</IsOutlined>
\t\t\t<HorizontalAlignment>Left</HorizontalAlignment>
\t\t\t<VerticalAlignment>Top</VerticalAlignment>
\t\t\t<TextFitMode>ShrinkToFit</TextFitMode>
\t\t\t<UseFullFontHeight>True</UseFullFontHeight>
\t\t\t<Verticalized>False</Verticalized>
\t\t\t<StyledText>
\t\t\t\t<Element>
\t\t\t\t\t<String xml:space="preserve">MATERIAL:</String>
\t\t\t\t\t<Attributes>
\t\t\t\t\t\t<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
\t\t\t\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
\t\t\t\t\t</Attributes>
\t\t\t\t</Element>
\t\t\t</StyledText>
\t\t</TextObject>
\t\t<Bounds X="130" Y="618" Width="2802.36363636364" Height="120" />
\t</ObjectInfo>
\t<ObjectInfo>
\t\t<TextObject>
\t\t\t<Name>WEIGHT</Name>
\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
\t\t\t<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
\t\t\t<LinkedObjectName />
\t\t\t<Rotation>Rotation0</Rotation>
\t\t\t<IsMirrored>False</IsMirrored>
\t\t\t<IsVariable>False</IsVariable>
\t\t\t<GroupID>-1</GroupID>
\t\t\t<IsOutlined>False</IsOutlined>
\t\t\t<HorizontalAlignment>Left</HorizontalAlignment>
\t\t\t<VerticalAlignment>Top</VerticalAlignment>
\t\t\t<TextFitMode>ShrinkToFit</TextFitMode>
\t\t\t<UseFullFontHeight>True</UseFullFontHeight>
\t\t\t<Verticalized>False</Verticalized>
\t\t\t<StyledText>
\t\t\t\t<Element>
\t\t\t\t\t<String xml:space="preserve">WEIGHT:</String>
\t\t\t\t\t<Attributes>
\t\t\t\t\t\t<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
\t\t\t\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
\t\t\t\t\t</Attributes>
\t\t\t\t</Element>
\t\t\t</StyledText>
\t\t</TextObject>
\t\t<Bounds X="130" Y="810.272727272727" Width="2134.72727272727" Height="120" />
\t</ObjectInfo>
\t<ObjectInfo>
\t\t<ImageObject>
\t\t\t<Name>GRAPHIC</Name>
\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
\t\t\t<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
\t\t\t<LinkedObjectName />
\t\t\t<Rotation>Rotation0</Rotation>
\t\t\t<IsMirrored>False</IsMirrored>
\t\t\t<IsVariable>False</IsVariable>
\t\t\t<GroupID>-1</GroupID>
\t\t\t<IsOutlined>False</IsOutlined>
\t\t\t<Image>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</Image>
\t\t\t<ScaleMode>None</ScaleMode>
\t\t\t<BorderWidth>0</BorderWidth>
\t\t\t<BorderColor Alpha="255" Red="0" Green="0" Blue="0" />
\t\t\t<HorizontalAlignment>Center</HorizontalAlignment>
\t\t\t<VerticalAlignment>Center</VerticalAlignment>
\t\t</ImageObject>
\t\t<Bounds X="679.818181818181" Y="57" Width="1824.90909090909" Height="344.727272727273" />
\t</ObjectInfo>
</DieCutLabel>
          `;
  return dymo.label.framework.openLabelXml(labelXml)
}